import React from "react";
import ContentLoader from "react-content-loader";
import { MainContent } from "./styles";
import { EntityListSkeleton } from "../../components/EntityListRow";
import {
  FiSearch,
  FiDollarSign,
  FiPercent,
  FiPackage,
  FiUsers,
} from "react-icons/fi";

const SuppliersLoadingSkeleton = ({ isDark = true }) => {
  const backgroundColor = isDark ? "#1a1a1a" : "#f0f0f0";
  const foregroundColor = isDark ? "#2a2a2a" : "#e5e7eb";

  return (
    <>
      {/* KPI Cards Principais */}
      <div className="kpi-cards main-stats">
        {[
          { icon: FiUsers, label: "Fornecedores Cadastrados", cls: "primary" },
          { icon: FiDollarSign, label: "Total de Compras", cls: "success" },
          { icon: FiPercent, label: "Total de Impostos", cls: "info" },
        ].map((item, i) => (
          <div key={`kpi-${i}`} className={`kpi-card ${item.cls}`}>
            <div className="card-content">
              <div className="thumb">
                <item.icon />
              </div>
              <div className="text">
                <p>
                  <ContentLoader
                    speed={2}
                    width={80}
                    height={20}
                    backgroundColor={backgroundColor}
                    foregroundColor={foregroundColor}
                  >
                    <rect x="0" y="0" rx="4" ry="4" width="80" height="20" />
                  </ContentLoader>
                </p>
                <p>{item.label}</p>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* KPI Cards de Impostos */}
      <div className="kpi-cards tax-stats">
        {[
          { label: "ICMS", cls: "tax-icms" },
          { label: "PIS/COFINS", cls: "tax-piscofins" },
          { label: "IPI", cls: "tax-ipi" },
          { label: "IBS", cls: "tax-ibs" },
          { label: "CBS", cls: "tax-cbs" },
          { label: "IS", cls: "tax-is" },
        ].map((item, i) => (
          <div key={`tax-${i}`} className={`kpi-card compact ${item.cls}`}>
            <div className="card-content">
              <div className="thumb" />
              <div className="text">
                <p>
                  <ContentLoader
                    speed={2}
                    width={70}
                    height={18}
                    backgroundColor={backgroundColor}
                    foregroundColor={foregroundColor}
                  >
                    <rect x="0" y="0" rx="4" ry="4" width="70" height="18" />
                  </ContentLoader>
                </p>
                <p>{item.label}</p>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Filtros */}
      <div className="filters-section">
        <div className="search-box">
          <FiSearch />
          <ContentLoader
            speed={2}
            width={300}
            height={14}
            backgroundColor={backgroundColor}
            foregroundColor={foregroundColor}
            style={{ marginLeft: "8px" }}
          >
            <rect x="0" y="0" rx="3" ry="3" width="300" height="14" />
          </ContentLoader>
        </div>
      </div>

      {/* Conteúdo Principal */}
      <MainContent>
        {/* Tabela de Fornecedores */}
        <div className="suppliers-table">
          <div className="table-header">
            <div className="header-cell fornecedor">Fornecedor</div>
            <div className="header-cell">ICMS</div>
            <div className="header-cell">PIS</div>
            <div className="header-cell">COFINS</div>
            <div className="header-cell">Compras</div>
            <div className="header-cell">Impostos</div>
          </div>

          <div className="table-body">
            <EntityListSkeleton
              rowCount={10}
              columns={[
                { width: "minmax(0, 2fr)" },
                { width: "minmax(0, 1fr)" },
                { width: "minmax(0, 1fr)" },
                { width: "minmax(0, 1fr)" },
                { width: "minmax(0, 1.2fr)" },
                { width: "minmax(0, 1fr)" },
              ]}
            />
          </div>
        </div>

        {/* Card de UFs — Donut Compacto */}
        <div className="stats-section chart-card compact-categories">
          <div className="donut-wrapper">
            <div className="donut-header">
              <h4>Fornecedores por UF</h4>
              <p>Distribuição por estado</p>
            </div>
            <div className="donut-chart">
              <div style={{ width: "180px", height: "180px", display: "flex", alignItems: "center", justifyContent: "center" }}>
                <div style={{
                  width: "40px",
                  height: "40px",
                  border: "4px solid rgba(139, 92, 246, 0.2)",
                  borderTop: "4px solid #8b5cf6",
                  borderRadius: "50%",
                  animation: "spin 1s linear infinite"
                }}></div>
              </div>
              <style>{`
                @keyframes spin {
                  0% { transform: rotate(0deg); }
                  100% { transform: rotate(360deg); }
                }
              `}</style>
              <div className="donut-center">
                <span className="donut-total">—</span>
                <span className="donut-label">Estados</span>
              </div>
            </div>
            <div className="categories-list">
              {[...Array(5)].map((_, i) => (
                <div key={`uf-${i}`} className="category-item">
                  <div className="category-header">
                    <div className="category-color" style={{ background: ["#3b82f6", "#10b981", "#f59e0b", "#8b5cf6", "#06b6d4"][i] }} />
                    <span className="category-name">
                      <ContentLoader speed={2} width={60} height={11} backgroundColor={backgroundColor} foregroundColor={foregroundColor}>
                        <rect x="0" y="0" rx="3" ry="3" width="60" height="11" />
                      </ContentLoader>
                    </span>
                    <span className="category-count">
                      <ContentLoader speed={2} width={30} height={11} backgroundColor={backgroundColor} foregroundColor={foregroundColor}>
                        <rect x="0" y="0" rx="3" ry="3" width="30" height="11" />
                      </ContentLoader>
                    </span>
                  </div>
                  <div className="category-bar">
                    <div className="category-progress" style={{ width: `${100 - i * 18}%`, background: ["#3b82f6", "#10b981", "#f59e0b", "#8b5cf6", "#06b6d4"][i] }} />
                  </div>
                  <div className="category-value">
                    <ContentLoader speed={2} width={80} height={10} backgroundColor={backgroundColor} foregroundColor={foregroundColor}>
                      <rect x="0" y="0" rx="3" ry="3" width="80" height="10" />
                    </ContentLoader>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </MainContent>
    </>
  );
};

export default SuppliersLoadingSkeleton;
